import clsx from "clsx";
import { cn } from "@/core/helpers/cn";
import { ChevronsUpIcon, Lock3Icon } from "@/shared/icons";

type Props = {
  level: number;
  className?: string;
};

export default function InventorySafeUpgradeLevel({ level, className }: Props) {
  return (
    <div className={cn("flex flex-col items-center justify-center shrink-0 w-full", className)}>
      <div
        className={clsx(
          "flex flex-col items-center justify-center h-[3.625rem] w-[3.625rem] bg-[#18181833]",
          "border border-[#1A1A1A] rounded-[1rem]",
        )}
      >
        <Lock3Icon size={20} className="text-[#84FF97]" />
      </div>
      <div className="text-16 font-bold mt-5 text-center">Купите улучшения сейфа</div>
      <div className="text-15 font-medium mt-2.5 text-center text-white/60 w-[21rem]">
        Чтобы разблокировать данную ячейку необходимо купить следующее улучшение сейфа
      </div>
      <div className="w-[3.625rem] h-[1px] text-white/5 my-5" />
      <div className="flex items-center gap-2.5">
        <ChevronsUpIcon size={12} className="text-white/50" />
        <div className="text-14 font-medium text-white/30">
          Текущий уровень улучшения сейфа:
          <span className="ml-2 text-14 font-bold text-[#84FF97]">{level}</span>
        </div>
      </div>
    </div>
  );
}
